module.exports = __webpack_public_path__ + "img/invoice - 副本.74a8630d.jpg";